/* STEP 2 — What to update.
   Three mode option-cards (Rates only / TAT only / Rates + TAT) drive which steps
   appear and which files generate. The rate-card effective date lives on the
   Upload Rates step (it only applies to rates). Mirrors m0.js drawScope. */
import React from 'react'
import PropTypes from 'prop-types'
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined'
import ScheduleOutlinedIcon from '@mui/icons-material/ScheduleOutlined'
import SyncOutlinedIcon from '@mui/icons-material/SyncOutlined'
import WizardFooter from './WizardFooter'

const MODES = [
  {
    id: 'rates',
    icon: PaymentsOutlinedIcon,
    t: 'Rates only',
    d: 'Push new zone × weight-slab rates. Creates a new rate-card version.',
  },
  {
    id: 'tat',
    icon: ScheduleOutlinedIcon,
    t: 'TAT only',
    d: 'Revise delivery TAT (min/max days) per zone. No rate-card version change.',
  },
  {
    id: 'both',
    icon: SyncOutlinedIcon,
    t: 'Rates + TAT',
    d: 'Update rates and TAT together in one governed change.',
  },
]

export default function StepScope({U, onSetScope, onBack, onNext}) {
  const cur = U.scope.rates && U.scope.tat ? 'both' : U.scope.rates ? 'rates' : 'tat'

  return (
    <>
      <div className='card card-pad'>
        <h3 style={{margin: '0 0 6px'}}>What do you want to update?</h3>
        <p className='sub' style={{margin: '0 0 16px'}}>
          The wizard only shows the steps you need — the stepper above reshapes as you choose. Set the
          rate-card effective date on the Upload Rates step; TAT applies immediately.
        </p>
        <div
          className='row gap12'
          style={{display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'stretch'}}
        >
          {MODES.map((m, i) => {
            const Icon = m.icon
            return (
              <div
                key={m.id}
                className={'mode-card' + (cur === m.id ? ' sel' : '')}
                style={{animationDelay: i * 45 + 'ms'}}
                onClick={() => onSetScope({rates: m.id !== 'tat', tat: m.id !== 'rates'})}
              >
                <span className='mic'>
                  <Icon style={{width: 18, height: 18}} />
                </span>
                <div>
                  <div style={{fontWeight: 700, fontSize: 13.5}}>{m.t}</div>
                  <div className='muted' style={{fontSize: 12, marginTop: 2}}>
                    {m.d}
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </div>

      <div>
        <WizardFooter showBack last={false} onBack={onBack} onNext={onNext} />
      </div>
    </>
  )
}

StepScope.propTypes = {
  U: PropTypes.object,
  onSetScope: PropTypes.func,
  onBack: PropTypes.func,
  onNext: PropTypes.func,
}
